/******************************************************/
/******************************************************/
/***                                                ***/
/***   CONFIGURATION DU HEADER DE L'APPLICATION :   ***/
/***                                                ***/
/******************************************************/
/******************************************************/
const ApplicationHeaderConfig = {
  headerClass: "p-0",
  /*****************************/
  /* Logo République Française */
  /*****************************/
  blocMarque: {
    show: true,
    src: "bloc-marque.svg",
  },
  /************************************************************/
  /* Logo, qui peut être composé d'une image et/ou d'un texte */
  /************************************************************/
  logo: {
    show: true,
    image: {
      // emplacement de l'image :
      src: "",
      altText : ``,
      //src: "dmo_custom/dmo.svg",
      // taille de l'image [width,height,unity] :
      dimensions : [],
      // style de l'image :
      class: "align-top"
    }
  },
  /*************************/
  /* Bouton de recherche : */
  /*************************/
  applicationSearcher: {
    // afficher ?
    show: false,
    // style de l'icône :
    iconColor: "professionnel",
    // couleur de fond du bouton :
    buttonColor: "gray-100",
    // classes du bouton :
    buttonClass: "text-professionnel",
    // outil de recherche :
    searcherInputColor: "primary",
    searcherClass: "btn-gray-100 border-gray-400",
    searcherText : "rechercher sur CLIR",
    searcherIconColor: "professionnel",
  },
  /*****************/
  /* Bouton User : */
  /*****************/
  applicationUser: {
    // afficher ?
    show: true,
    // style de l'icône :
    iconColor: "white",
    // couleur de fond du bouton :
    buttonColor: "gray-800",
    // classes du bouton :
    buttonClass: "",
    // afficher user en texte sous les icônes ?
    showText: true,
    textClass: ""
  },
  /************************/
  /* Bouton Déconnexion : */
  /************************/
  applicationDisconnector: {
    // afficher ?
    show: true,
    // style de l'icône :
    iconColor: "white",
    // couleur de fond du bouton :
    buttonClass: "btn-gray-900"
  },
  /**********************/
  /* Bouton Connexion : */
  /**********************/
  applicationConnector: {
    // afficher ?
    show: true,
    // style de l'icône :
    iconColor: "white",
    // couleur de fond du bouton :
    buttonColor: "primary",
    // classes du bouton :
    buttonClass: "text-truncate-text-start",
    text: "Connectez-vous"
  },
  /*********************/
  /* Boutons ajoutés : */
  /*********************/
  customConnectedButtons: [
  ]
};


export default ApplicationHeaderConfig;
